import { error } from '@utils/logger'
import { apiFetch } from '@utils/fetch'

export interface SyncUsersResponse {
  status: string
  message: string
}

export interface RebuildUserVenueAccessResponse {
  status: string
  clerk_user_id: string
  venues_granted: string[]
}

export async function syncUsers(): Promise<SyncUsersResponse | null> {
  try {
    const resp = await apiFetch('/api/admin/users/sync', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    })

    if (!resp.ok) {
      error('failed to sync users', resp.statusText)
      return null
    }

    const data = await resp.json()
    return data as SyncUsersResponse
  } catch (err) {
    error('failed to sync users', err)
    return null
  }
}

export async function rebuildUserVenueAccess(
  clerkUserId: string
): Promise<RebuildUserVenueAccessResponse | null> {
  try {
    const resp = await apiFetch('/api/admin/users/rebuild-venue-access', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ clerk_user_id: clerkUserId })
    })

    if (!resp.ok) {
      error('failed to rebuild user venue access', resp.statusText)
      return null
    }

    const data = await resp.json()
    return data as RebuildUserVenueAccessResponse
  } catch (err) {
    error('failed to rebuild user venue access', err)
    return null
  }
}

export default { syncUsers, rebuildUserVenueAccess }